import { NaturalNumber_Schema, WholeNumber_Schema } from "@/utilities";
import { z } from "zod";

// Fielter field option schema
export const FilterOption_Schema = z.object({
  id: NaturalNumber_Schema,
  value: z.string(),
  slug: z.string(),
  active: z.boolean(),
  ifSelectedCount: WholeNumber_Schema,
});

export enum FilterType {
  Text = "text",
  SingleSelect = "single-select",
  MultiSelect = "multi-select",
  Range = "range",
}

/** Received from API, we don't work with it, we transform it into FilterType. */
enum Response_FieldType {
  ChooseOne = "choose_one",
}

/** Received from API, we don't work with it, we transform it into FilterType. */
enum Response_FieldViewType {
  Dropdown = "dropdown",
}

export const FilterDefinition_Schema = z
  .object({
    id: z.number(), // Can be negative!
    slug: z.string(),
    name: z.string(),
    type: z.enum(Response_FieldType),
    viewType: z.enum(Response_FieldViewType),
    values: z.array(FilterOption_Schema),
  })
  .transform(({ viewType, type, ...rest }) => ({
    ...rest,
    type: mapFieldDefinitionToFilterType(viewType, type),
  }));

// Sort option schema (no count)
export const SortOption_Schema = z.object({
  value: z.string(),
  label: z.string(),
});

// Sort definition schema
export const SortDefinition_Schema = z.object({
  field: z.string(),
  label: z.string(),
  options: z.array(SortOption_Schema),
  default: z.string(),
});

// Helpers:

/** Slug for the identification/fulltext filter field. */
export const IDENTIFICATION_FILTER_SLUG = "identification";

export function mapFieldDefinitionToFilterType(viewType: Response_FieldViewType, type: Response_FieldType): FilterType {
  const error = new Error(`Unknown combination of viewType: ${viewType} and type: ${type}`);

  if (viewType === Response_FieldViewType.Dropdown) {
    if (type === Response_FieldType.ChooseOne) {
      return FilterType.SingleSelect;
    } else {
      throw error;
    }
  } else {
    throw error;
  }
}
